import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { EmptyStateImages, Heading, Text, TextButton } from '../../../../../components/common';
import { ExternalSourcesConfigs, NewExternalSourcesConfigs } from '../../../constants/Sources';
import { IOuter } from './EmptyState.types';

import styles from './EmptyState.scss';

export const EmptyState: FC<IOuter> = ({
  isSearch,
  searchQuery,
  isRoot,
  isWixSitesRoot,
  source,
  areNotAllMediaTypesSelected,
  clearAllExtendedFilters,
}) => {
  const isNewColorsBrandingEnabled = window.isNewColorsBrandingEnabled;
  const configMap = isNewColorsBrandingEnabled ? NewExternalSourcesConfigs : ExternalSourcesConfigs;
  const config = configMap[source];

  const emptyFolderWithFilters = (
    <FormattedMessage
      id="empty-state.no-media-types-subtitle-new"
      values={{
        clearFilters: (
          <TextButton size={isNewColorsBrandingEnabled ? 'small' : 'medium'} as="a" onClick={clearAllExtendedFilters}>
            <FormattedMessage id="empty-state.no-media-types-subtitle.clear-filters" />
          </TextButton>
        ),
      }}
    />
  );

  const rootMessage = areNotAllMediaTypesSelected ? emptyFolderWithFilters : config.emptyRootFolderMessage;
  const folderMessage = areNotAllMediaTypesSelected ? emptyFolderWithFilters : config.emptyFolderMessage;

  const getTitle = () => {
    if (isSearch) {
      const key = isNewColorsBrandingEnabled
        ? 'empty.state.board.search-no-media-title'
        : 'files-importer.search.empty.title';

      return <FormattedMessage id={key} />;
    }

    if (isRoot) {
      return config.emptyRootFolderTitle;
    }

    if (isWixSitesRoot) {
      return <FormattedMessage id="files-importer.empty-root-folder.title.wix-sites-root" />;
    }

    return config.emptyFolderTitle;
  };

  const getMessage = () => {
    if (isSearch) {
      const key = isNewColorsBrandingEnabled
        ? 'empty.state.board.search-no-media-subtitle'
        : 'files-importer.search.empty.subtitle';
      return <FormattedMessage id={key} values={{ query: searchQuery }} />;
    }

    if (isRoot) {
      return rootMessage;
    }

    if (isWixSitesRoot) {
      return <FormattedMessage id="files-importer.empty-root-folder.message.wix-sites-root" />;
    }

    return folderMessage;
  };

  const title = getTitle();
  const message = getMessage();
  const newBrandingIcon = isSearch ? EmptyStateImages.Search : EmptyStateImages.SiteFiles;

  return (
    <div className={styles.wrapper}>
      {isNewColorsBrandingEnabled ? (
        <img src={newBrandingIcon} className={styles.newBrandingIcon} />
      ) : (
        <div className={styles.icon} />
      )}

      <Heading size="medium" className={styles.text}>
        {title}
      </Heading>

      <Text
        tagName="div"
        weight="thin"
        size={isNewColorsBrandingEnabled ? 'small' : 'medium'}
        secondary
        className={styles.text}
      >
        {message}
      </Text>
    </div>
  );
};
